import clsx from 'clsx';

type IconProps = JSX.IntrinsicElements['svg'] & {
    direction?: 'up' | 'right' | 'down' | 'left';
  };

function Icon({
    children,
    className,
    fill = 'currentColor',
    stroke,
    ...props
}: IconProps) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 20 20"
            {...props}
            fill={fill}
            stroke={stroke}
            className={clsx('burgerMenu', className)}
        >
            {children}
        </svg>
    );
}

export default function MenuIcon(props: IconProps) {
    return (
      <Icon {...props} stroke={props.stroke || 'currentColor'}>
        <line x1="3" y1="6.375" x2="17" y2="6.375" strokeWidth="1.25" />
        <line x1="3" y1="10.375" x2="17" y2="10.375" strokeWidth="1.25" />
        <line x1="3" y1="14.375" x2="17" y2="14.375" strokeWidth="1.25" />
      </Icon>
    );
  }